import Plan from "./pages/plan/store";
import Execution from "./pages/execution/store";
import Transactions from "@/modules/ngo/transactions/store";

export default {
  namespaced: true,
  modules: {
    Plan,
    Execution,
    Transactions
  },
};
